import { useLocation, useNavigate } from 'react-router-dom'

import { Path } from 'constants/router'
import constate from 'constate'
import { useMemo } from 'react'

export enum WorkspaceTab {
  WORKSPACE = 'information',
  PLAN = 'plan',
  MEMBERS = 'members',
  BRAND_ASSETS = 'brand-assets',
  INTEGRATIONS = 'integrations',
  BILLING = 'billing',
}

/** Context provider for workspace navigation tabs */
export const [WorkspaceNavigationContextProvider, useWorkspaceNavigation] = constate(() => {
  const navigate = useNavigate()
  const location = useLocation()

  // Derive active tab from URL pathname - single source of truth
  const activeTab = useMemo((): WorkspaceTab => {
    const pathname = location.pathname

    if (pathname.includes('/plan')) return WorkspaceTab.PLAN
    if (pathname.includes('/members')) return WorkspaceTab.MEMBERS
    if (pathname.includes('/brand-assets')) return WorkspaceTab.BRAND_ASSETS
    if (pathname.includes('/integrations')) return WorkspaceTab.INTEGRATIONS
    if (pathname.includes('/billing')) return WorkspaceTab.BILLING

    return WorkspaceTab.WORKSPACE
  }, [location.pathname])

  const handleChangeTab = (selectedTab: WorkspaceTab) => {
    if (Object.values(WorkspaceTab).includes(selectedTab)) {
      navigate(Path.WORKSPACE_SETTINGS_TAB.replace(':tab', selectedTab))
    }
  }

  return {
    handleChangeTab,
    activeTab,
  }
})
